var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_101",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1007",
    "data-name": "Raggruppa 1007",
    transform: "translate(-756.5 -3114.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1006",
    "data-name": "Raggruppa 1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1005",
    "data-name": "Raggruppa 1005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1004",
    "data-name": "Raggruppa 1004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_995",
    "data-name": "Raggruppa 995",
    transform: "translate(398 2560)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_978",
    "data-name": "Raggruppa 978"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 358.5, 554.5)",
    filter: "url(#Ellisse_101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_101-2",
    "data-name": "Ellisse 101",
    transform: "translate(10.5 7.5)",
    fill: "#fff",
    stroke: "#6466f1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_977",
    "data-name": "Raggruppa 977",
    transform: "translate(28.335 8.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1551",
    "data-name": "Tracciato 1551",
    d: "M122.135,52.69a.541.541,0,0,1-.526.23,7.648,7.648,0,0,0-2.563.275,5.006,5.006,0,0,0-3.37,3.235,7.894,7.894,0,0,0-.455,2.715c0,.122.006.244-.007.365a.339.339,0,0,1-.357.327.343.343,0,0,1-.336-.351c-.024-.448-.021-.9-.07-1.343a6.5,6.5,0,0,0-1.028-2.964,1.065,1.065,0,0,1-.06-.1.291.291,0,0,1,.084-.405.279.279,0,0,1,.4.1c.225.394.456.786.643,1.2.155.342.252.71.386,1.1a5.779,5.779,0,0,1,4.292-4.519A5.787,5.787,0,0,1,114.87,48a5.8,5.8,0,0,1-4.27,4.56,6.249,6.249,0,0,1,.784.284c.469.244.925.512,1.377.787.218.133.261.312.155.462s-.279.139-.5-.007a9.526,9.526,0,0,0-1.1-.656,6.508,6.508,0,0,0-2.9-.512c-.134,0-.269.005-.4,0-.247-.009-.393-.141-.394-.352s.136-.344.387-.353c.524-.02,1.051-.006,1.571-.062a5.12,5.12,0,0,0,4.537-3.592,7.69,7.69,0,0,0,.41-2.568c0-.122,0-.244,0-.365a.339.339,0,0,1,.367-.336.343.343,0,0,1,.331.353c.015.378.009.757.041,1.133a6.654,6.654,0,0,0,.985,3.059,4.957,4.957,0,0,0,3.245,2.2,9.539,9.539,0,0,0,2.176.166.447.447,0,0,1,.469.259v.231Z",
    transform: "translate(246.362 518.233)",
    fill: "#6466f1",
    stroke: "#5b5cd8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1552",
    "data-name": "Tracciato 1552",
    d: "M5.449,32a2.586,2.586,0,0,1-1.327-1.411A2.668,2.668,0,0,1,2.781,32a2.647,2.647,0,0,1,1.334,1.4,2.414,2.414,0,0,1,.119-.222.282.282,0,0,1,.512.225c-.036.129-.118.246-.141.376-.067.376-.121.755-.167,1.135-.018.151-.052.279-.2.342-.218.093-.419-.063-.44-.326a6.887,6.887,0,0,0-.084-.858A2.076,2.076,0,0,0,1.67,32.332c-.166-.009-.332-.013-.5-.02a.312.312,0,1,1,.014-.621,3.344,3.344,0,0,0,1.228-.165,2.1,2.1,0,0,0,1.336-1.779A5.867,5.867,0,0,0,3.8,29.1c.013-.243.122-.375.32-.372s.308.135.311.381a3.147,3.147,0,0,0,.356,1.535A2.069,2.069,0,0,0,6.6,31.682c.153.011.307,0,.46.009A.314.314,0,0,1,7.4,32c0,.184-.132.293-.341.314-.386.039-.772.085-1.155.143a1.5,1.5,0,0,0-.32.125c-.2.081-.359.039-.43-.113s0-.3.182-.406L5.449,32Z",
    transform: "translate(348 534)",
    fill: "#6466f1",
    stroke: "#5b5cd8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1553",
    "data-name": "Tracciato 1553",
    d: "M73.407,246.381a2.657,2.657,0,0,1-1.338,1.407,2.654,2.654,0,0,1,1.338,1.41,2.6,2.6,0,0,1,1.32-1.4l-.137-.087a.289.289,0,1,1,.258-.516,4.121,4.121,0,0,0,.633.21,7.827,7.827,0,0,0,.858.072c.218.014.339.119.34.307s-.129.3-.351.32a6.008,6.008,0,0,0-1.135.143,2,2,0,0,0-1.4,1.733,7.435,7.435,0,0,0-.076.764c-.016.206-.118.32-.3.323a.3.3,0,0,1-.317-.329,3.448,3.448,0,0,0-.283-1.439,1.97,1.97,0,0,0-1.606-1.157,6.768,6.768,0,0,0-.727-.041c-.216-.009-.34-.115-.345-.3s.117-.3.345-.322a6.111,6.111,0,0,0,1.1-.133,1.993,1.993,0,0,0,1.439-1.7,6.626,6.626,0,0,0,.077-.783c.015-.214.119-.343.3-.348a.306.306,0,0,1,.318.348,3.394,3.394,0,0,0,.3,1.456.29.29,0,1,1-.519.245c-.024-.045-.044-.092-.086-.178Z",
    transform: "translate(282.038 328.593)",
    fill: "#6466f1",
    stroke: "#5b5cd8",
    strokeWidth: 0.5
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon);
export default __webpack_public_path__ + "static/media/tutorial-icon.e2fe394837cde40434dd9c5f14de23b7.svg";
export { ForwardRef as ReactComponent };